import React, { useContext } from 'react';
import { Layout, Cell, Box, Heading, Text } from '@wix/design-system';
import { PluginCard } from './pluginCard';

import { PluginsContext } from '../pluginsContext';
import { useTranslation } from '../../useTranslation';
import { WidgetDataContext } from '../widgetDataContext';

export const PluginsGrid = () => {
  const { plugins } = useContext(PluginsContext);
  const { widgetName } = useContext(WidgetDataContext);

  const [t] = useTranslation();

  return (
    <>
      <Box marginBottom="SP5" display="flex" direction="vertical">
        <Heading size="large">
          {t('PLATFORM_Widget_Slots_Modal_Title', {
            widget_name: widgetName,
          })}
        </Heading>

        <Text size="medium" weight="thin">
          {t('PLATFORM_Widget_Slots_Modal_Subtitle')}
        </Text>
      </Box>

      <Layout gap="SP4" cols={12}>
        {plugins.map((plugin) => (
          <Cell span={4} rows={1} key={plugin.id}>
            <PluginCard plugin={plugin} />
          </Cell>
        ))}
      </Layout>
    </>
  );
};
